import {
    Info,
    CalendarMonth,
    Euro,
    FolderShared,
    AddTask,
    Quiz,
    Handshake,
    Waves,
    ListAlt,
    LocalHospital,
    People,
    Favorite,
    MenuBook,
} from "@mui/icons-material";
import { ROLES } from "../../utils/constants";
import { getIntakeFormTypeFromClientNumber } from "../../utils/getClientAge";
import { canSeeLogbook } from "./logbook/logbookFeature";

export const tabs = [
    {
        icon: <Info />,
        entity: "detail",
        label: "Detalhes",
        isDetail: true,
    },
    {
        icon: <CalendarMonth />,
        entity: "sessions",
        label: "Sessões",
    },
    {
        icon: <ListAlt />,
        entity: "intake_form",
        label: "Anamnese",
        filter: (context: { item?: any; userRole?: string }) => {
            const clientType = context.item?.client?.client_id
                ? getIntakeFormTypeFromClientNumber(context.item.client.client_id)
                : "";
            const isValidClientType = clientType === "intake_forms_child" || clientType === "intake_forms_adult";
            const isAuthorizedRole =
                context.userRole &&
                [
                    ROLES.admin,
                    ROLES.shilan,
                    ROLES.neurofeedback_director,
                    ROLES.technical_director,
                    ROLES.nfb_and_theurapist,
                    ROLES.theurapist,
                    ROLES.tech_admin,
                    ROLES.nfb_techncians,
                    ROLES.substituion_joana_temp,
                    ROLES.client_owner
                ].includes(context.userRole);
            return isValidClientType && !!isAuthorizedRole;
        },
    },
    {
        icon: <LocalHospital />,
        entity: "treatment_prescription",
        label: "Prescrição",
    },
    {
        icon: <Waves />,
        entity: "neurofeedback_data",
        label: "Neurofisiologia",
    },
    {
        icon: <Favorite />,
        entity: "psychology",
        label: "Psicologia",
    },
    {
        icon: <FolderShared />,
        entity: "notes",
        label: "Gestão de Caso",
    },
    {
        icon: <MenuBook />,
        entity: "logbook",
        label: "Diário de Bordo",
        filter: (context: any) => canSeeLogbook(context.userRole),
    },
    {
        icon: <Euro />,
        entity: "orders",
        label: "Compras",
        filter: (context: { item?: any; userRole?: string }) => {
            const isAuthorizedRole =
                context.userRole &&
                [
                    ROLES.admin,
                    ROLES.shilan,
                    ROLES.neurofeedback_director,
                    ROLES.technical_director,
                    ROLES.recepcionist,
                    ROLES.virtual_assistant,
                    ROLES.tech_admin,
                    ROLES.back_office
                ].includes(context.userRole);
            return !!isAuthorizedRole;
        },
    },

/*  Hidden
    {
        icon: <TextSnippet />,
        entity: "feedbacks",
        label: "Feedbacks",
    },
*/
    {
        icon: <AddTask />,
        entity: "tasks",
        label: "Tarefas",
    },
    {
        icon: <Quiz />,
        entity: "customer_surveys",
        label: "Questionários",
    },
    {
        icon: <People />,
        entity: "relatives",
        label: "Parentes",
    },
    {
        icon: <Handshake />,
        entity: "professional_partners",
        label: "Parceiros",
    },
/*  Hidden
    {
        icon: <History />,
        entity: "timeline",
        label: "Histórico",
    },
*/
];
